import { TextInput } from "app/components/FormInputs/FormInputs";
import GeniusSiteTracking from "app/components/GeniusTracking/GeniusSiteTracking";
import ENV from "config";
import React, { Component, lazy, Suspense } from "react";
import { FormattedMessage } from "react-intl";
const LoadingSpinner: React.LazyExoticComponent<any> = lazy(
  () => import("app/components/LoadingSpinner/LoadingSpinner")
);
type Props = {
  handleChange: (...args: Array<any>) => any;
  login: (...args: Array<any>) => any;
  loginLoading: boolean;
  I18n: any;
  loginError: string;
  displayForgottenEmail: (...args: Array<any>) => any;
  forgottenPassword: (...args: Array<any>) => any;
  displayResendEmailVerification: (...args: Array<any>) => any;
  displayForgottenUsername: (...args: Array<any>) => any;
};

class AuthScreenForm extends Component<Props> {
  render(): React.ReactElement<React.ComponentProps<"div">, "div"> {
    const {
      handleChange,
      login,
      loginLoading,
      I18n,
      loginError,
      forgottenPassword,
      displayResendEmailVerification,
      displayForgottenUsername,
      displayForgottenEmail,
    } = this.props;
    return (
      <div className="auth-screen__form">
        <form onSubmit={login}>
          <div className="auth-screen__form__inputs">
            {loginLoading ? (
              <Suspense fallback={<div className="fallback">loading...</div>}>
                <LoadingSpinner />
              </Suspense>
            ) : (
              <React.Fragment>
                {ENV.CSS_THEME === "GALAXYBET" && (
                  <label className="extra-translation-user">昵称</label>
                )}
                <TextInput
                  type="text"
                  id="username"
                  className="auth-screen__form__input"
                  removeDefaultStyle={true}
                  label={I18n.username}
                  onChange={handleChange}
                />

                <span className="error-msg">{loginError}</span>
                {ENV.CSS_THEME === "GALAXYBET" && (
                  <label className="extra-translation-password">密码</label>
                )}
                <TextInput
                  type="password"
                  id="password"
                  className="auth-screen__form__input"
                  removeDefaultStyle={true}
                  label={I18n.password}
                  onChange={handleChange}
                />
                <div className={"auth-screen__form__user-links"}>
                  <FormattedMessage tagName="span" id="login-forgotten" />
                  <div
                    className="auth-screen__form__forgotten-username"
                    onClick={() => displayForgottenUsername()}
                  >
                    <FormattedMessage tagName="span" id="login-username" />,
                  </div>
                  <div
                    className="auth-screen__form__forgotten-password"
                    onClick={forgottenPassword}
                  >
                    <FormattedMessage tagName="span" id="login-password" />
                  </div>
                  <div
                    className="auth-screen__form__forgotten-email"
                    onClick={() => displayForgottenEmail()}
                  >
                    <FormattedMessage tagName="span" id="home-email" />
                  </div>
                </div>

                <div
                  className="auth-screen__form__send-verification-email"
                  onClick={displayResendEmailVerification}
                >
                  <FormattedMessage
                    tagName="span"
                    id="login-resend-verification-email"
                  />
                </div>
              </React.Fragment>
            )}
          </div>
          <div className="auth-screen__form__submit">
            <button id="login_button" type="submit" disabled={loginLoading}>
              <FormattedMessage tagName="span" id="login-login" />
              {ENV.CSS_THEME === "GALAXYBET" && " / 登录"}
            </button>
          </div>
        </form>
        <GeniusSiteTracking
          targetSelector="#login_button"
          eventType="click"
          pageName="loggedin"
          value="login"
          currency="USD"
        />
      </div>
    );
  }
}

export default AuthScreenForm;
